import { render } from "./Archive.vue?vue&type=template&id=2c6b3844&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=2c6b3844&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6b3844"]])

export default __exports__